export class CurrentPatient {
  PatientID: string;
  ObjectId: string;
  PatientName: string;
  ParentObjectName: string;
}

export class ControlSetup {
  controlkey: string;
  controlvalue: string;
}

export class PerioChart {
  CaseWorkItemFormsId: string;
  ChartDateTime: Date;
  Description: string;
  PatientId: string;
  PerioChartID: string;
  dataPerioChartTeeth: any[];
  isComparing: boolean;
  xauditCreatedBy: string;
  xauditCreatedOn: string;
  xauditDeleted: boolean;
  xauditModifiedBy: string;
  xauditModifiedOn: string;
  xauditTableRowID: string;
}

export class ValidationParameters {
  ExecOrder: number;
  LimitHigh: string;
  LimitLow: string;
  Parameter: string;
  PerioValidationID: string;
  enumPerioValidationID: string;
  enumPerioValidationVisualID: string;
  xauditCreatedBy: string;
  xauditCreatedOn: Date;
  xauditDeleted: boolean;
  xauditModifiedBy: string;
  xauditModifiedOn: Date;
  xauditTableRowID: string;
}

export class cfgTooth {
  Name: string;
  PhysicalHorderLR: number;
  PhysicalVorder: number;
  ToothId: string;
  cfgPerioSequenceSteps: cfgPerioSequenceStep[];
  cfgToothDescriptions: cfgToothDescription[];
  enumToothLocationId: string;
  xauditCreatedBy: string;
  xauditCreatedOn: Date;
  xauditDeleted: boolean;
  xauditModifiedBy: string;
  xauditModifiedOn: Date;
  xauditTableRowID: string;
}

export class cfgToothDescription {
  Notation: string;
  NotationDescription: string;
  ToothId: string;
  enumToothNumberingId: string;
  xauditCreatedBy: string;
  xauditCreatedOn: Date;
  xauditDeleted: boolean;
  xauditModifiedBy: string;
  xauditModifiedOn: Date;
  xauditTableRowID: string;
}

export class cfgPerioSequenceStep {
  InputControlName: string;
  KeyBoardControlName: string;
  PerioSequenceID: string;
  PerioSequenceStepID: string;
  SeqOrder: number;
  ToothControlName: string;
  xauditCreatedBy: string;
  xauditCreatedOn: Date;
  xauditDeleted: boolean;
  xauditModifiedBy: string;
  xauditModifiedOn: Date;
  xauditTableRowID: string;
}

export class PerioTooth {
  cfgTooth: cfgTooth;
  FacialBleedingC: boolean;
  FacialBleedingD: boolean;
  FacialBleedingM: boolean;
  FacialClinicalAttachmentLevelC: number;
  FacialClinicalAttachmentLevelD: number;
  FacialClinicalAttachmentLevelM: number;
  FacialGingovalMarginC: number;
  FacialGingovalMarginD: number;
  FacialGingovalMarginM: number;
  FacialMucogingovalJunctionC: number;
  FacialMucogingovalJunctionD: number;
  FacialMucogingovalJunctionM: number;
  FacialProbingDepthC: number;
  FacialProbingDepthD: number;
  FacialProbingDepthM: number;
  FacialSuppurationC: boolean;
  FacialSuppurationD: boolean;
  FacialSuppurationM: boolean;
  LingualBleedingC: boolean;
  LingualBleedingD: boolean;
  LingualBleedingM: boolean;
  LingualClinicalAttachmentLevelC: number;
  LingualClinicalAttachmentLevelD: number;
  LingualClinicalAttachmentLevelM: number;
  LingualGingovalMarginC: number;
  LingualGingovalMarginD: number;
  LingualGingovalMarginM: number;
  LingualMucogingovalJunctionC: number;
  LingualMucogingovalJunctionD: number;
  LingualMucogingovalJunctionM: number;
  LingualProbingDepthC: number;
  LingualProbingDepthD: number;
  LingualProbingDepthM: number;
  LingualSuppurationC: boolean;
  LingualSuppurationD: boolean;
  LingualSuppurationM: boolean;
  PerioChartID: string;
  PerioChartToothID: string;
  ToothBoneLoss: number;
  ToothComment: string;
  ToothId: string;
  ToothIsImplant: boolean;
  ToothIsMissing: boolean;
  ToothMobility: number;
  ToothRotationAngleX: number;
  ToothRotationAngleY: number;
  ToothRotationAngleZ: number;
  FacialPlaqueD: boolean;
  FacialPlaqueC: boolean;
  FacialPlaqueM: boolean;
  LingualPlaqueD: boolean;
  LingualPlaqueC: boolean;
  LingualPlaqueM: boolean;
  ToothFurcationGrade: number;
  FacialCalculusD: boolean;
  FacialCalculusC: boolean;
  FacialCalculusM: boolean;
  LingualCalculusD: boolean;
  LingualCalculusC: boolean;
  LingualCalculusM: boolean;
  xauditCreatedBy: string;
  xauditCreatedOn: Date;
  xauditDeleted: boolean;
  xauditModifiedBy: string;
  xauditModifiedOn: Date;
  xauditTableRowID: string;
  DISPLAY_UPDATE_VALUE: number;
}

export class PerioDisplayTooth {
  FacialClinicalAttachmentLevel: string;
  FacialFurcationGrade: string;
  FacialGingovalMargin: string;
  FacialMucogingovalJunction: string;
  FacialProbingDepth: string;
  LingualClinicalAttachmentLevel: string;
  LingualFurcationGrade: string;
  LingualGingovalMargin: string;
  LingualMucogingovalJunction: string;
  LingualProbingDepth: string;
  tooth: string;
}

export class PerioDisplayToothIssues {
  FacialBleeding: string;
  FacialSuppuration: string;
  FacialPlaque: string;
  FacialCalculus: string;
  LingualBleeding: string;
  LingualSuppuration: string;
  LingualPlaque: string;
  LingualCalculus: string;
  tooth: string;
}


export class PerioToothIndex {
  imageIndex: number;
  index: number;
}

export class PerioSummaryStats {
  meanProbingDepth: string;
  meanAttachmentLevel: string;
  plaquePercent: string;
  bleedingPercent: string;
}

export enum PerioSummarySelectType {
  ScreeningScore = 0,
  ProbingDepths = 1,
  ToothSummary = 2,
}

export class PerioSummarySelect {
  name: string;
  type: PerioSummarySelectType;
}

export class PerioProbingDepthsBySegment {
  averageProbingDepthS1: number;
  averageProbingDepthS2: number;
  averageProbingDepthS3: number;
  averageProbingDepthS4: number;
  averageProbingDepthS5: number;
  averageProbingDepthS6: number;
  lowestProbingDepthS1: number;
  lowestProbingDepthS2: number;
  lowestProbingDepthS3: number;
  lowestProbingDepthS4: number;
  lowestProbingDepthS5: number;
  lowestProbingDepthS6: number;
}
